import ViewMain from "pages";
import {detectPathUrl} from "helpers/detectPathUrl";
import ViewAuthentication from "pages/authentication";
import ViewApp from "pages/app";
import ViewError from "pages/error";
import {Invitations} from "components/Invitation/Invitations";

export const mainRoutes = [
    {
        name: "slash",
        route: "/",
        component: <ViewMain />,
    },
    {
        name: "main",
        route: detectPathUrl(''),
        component: <ViewMain />,
    },
    {
        name: "Authentication",
        route: detectPathUrl('authentication/*'),
        component: <ViewAuthentication />,
    },
    {
        name: "app",
        route: detectPathUrl('app/*'),
        component: <ViewApp />,
    },
    {
        name: "Authentication",
        route: detectPathUrl('assistant/invite/:id'),
        component: <Invitations />,
    },

    {
        name: "error",
        route: `*`,
        component: <ViewError />,
    }
];

